import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { EDIT_TENANT_GROUP_FIELDS } from 'Common/enums';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';

export const nameSchema = (validationT: (s: string, options?: any) => string) => {
    return Yup.string()
        .strict()
        .required(validationT('required', { field: EDIT_TENANT_GROUP_FIELDS.NAME }));
};

export const descriptionSchema = () => {
    return Yup.string().strict();
};

export const editTenantGroupSchema = (t: TFunction, existingTenantGroupNames: string[], initialName: string) => {
    const validationT = getTranslationValidationHandling(t);
    return Yup.object().shape({
        name: nameSchema(validationT).test({
            name: 'name',
            message: t('uniqueTenantGroupNameError'),
            test: (value = '') => {
                return !existingTenantGroupNames.includes(value.toLowerCase()) || value === initialName;
            }
        }),
        description: descriptionSchema()
    });
};
